import React from 'react';

import Checkbox from '../../inputs/Checkbox';
import SwitchToggle from '../../inputs/SwitchToggle';

const booleans = ['gostinska-ponudba', 'vstopnina'];

interface FilterOptionProps {
    label: string;
    checked: boolean;
    onChange: (isChecked: boolean) => void;
    filterSlug: string;
}
function FilterOption({ label, checked, onChange, filterSlug }: FilterOptionProps) {
    if (booleans.includes(filterSlug)) {
        return (
            <div>
                <SwitchToggle label={label} enabled={checked} onChange={(isChecked) => onChange(isChecked)} />
            </div>
        );
    }
    return (
        <div>
            <Checkbox label={label} isChecked={checked} onChange={(e) => onChange(e.target.checked)} />
        </div>
    );
}

FilterOption.propTypes = {};

export default FilterOption;
